import { Property } from '../property'
import { PropertySpec } from '../spec/property-spec'

export class PropertyConf {
  public propertyId: string
  public property: Property
  public values: string[] = []

  /**
   * Has to be populated.
   */
  public spec: PropertySpec
}
